export const emptyDepositoClienteForm = {
  id: '',
  nomeCliente: '',
  cnpjCliente: '',
  diasRecorrencia: '',
  diaEmissaoInicial: '',
  diaEmissaoFinal: '',
  tokenRastreamento: '',
  tokenRastreamentoAtivo: false,
  nomeResponsavelComercial: '',
  nomeResponsavelLancamento: '',
  nomeResponsavelFechamento: '',
  templateCabecalhoPaletizacao: '',
  templateItensPaletizacao: '',
  templateCabecalhoEtiquetagem: '',
  templateItensEtiquetagem: '',
  templateCabecalhoArmazenagem: '',
  templateItensArmazenagem: '',
  observacoesEmissao: ''
};

export const depositoClienteFormStructure = [
  [
    {
      name: 'id',
      label: 'Id',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'nomeCliente',
      label: 'Nome Cliente',
      placeholder: 'Digite o nome do cliente',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 }
    },
    {
      name: 'cnpjCliente',
      label: 'CNPJ',
      placeholder: 'Digite o CNPJ',
      component: 'MaskedInput',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 18,
      mask: [
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '/',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/
      ],
      guide: false
    },
    {
      name: 'diasRecorrencia',
      label: 'Dias Recorrencia',
      placeholder: 'Intervalo em dias',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 }
    }
  ],
  [
    {
      name: 'diaEmissaoInicial',
      label: 'Dia Emissao Inicial',
      placeholder: 'Dia 1-31',
      component: 'FormField',
      type: 'number',
      colProps: { md: 6 }
    },
    {
      name: 'diaEmissaoFinal',
      label: 'Dia Emissao Final',
      placeholder: 'Dia 1-31',
      component: 'FormField',
      type: 'number',
      colProps: { md: 6 }
    }
  ],
  [
    {
      name: 'tokenRastreamento',
      label: 'Token Rastreamento',
      placeholder: 'Token de acesso publico',
      component: 'FormField',
      type: 'text',
      colProps: { md: 8 },
      maxLength: 255
    },
    {
      name: 'tokenRastreamentoAtivo',
      label: 'Token Ativo',
      component: 'CheckBox',
      type: 'checkbox',
      colProps: { md: 4 }
    }
  ],
  [
    {
      name: 'nomeResponsavelComercial',
      label: 'Responsavel Comercial',
      placeholder: 'Nome do responsavel comercial',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 255
    },
    {
      name: 'nomeResponsavelLancamento',
      label: 'Responsavel Lancamento',
      placeholder: 'Nome do responsavel de lancamento',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 255
    },
    {
      name: 'nomeResponsavelFechamento',
      label: 'Responsavel Fechamento',
      placeholder: 'Nome do responsavel de fechamento',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
      maxLength: 255
    }
  ],
  [
    {
      name: 'observacoesEmissao',
      label: 'Observacoes Emissao',
      placeholder: 'Observacoes exibidas nos modais de cobranca apos os detalhes',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 12 },
      rows: 4
    }
  ],
  [
    {
      name: 'templateCabecalhoPaletizacao',
      label: 'Cabecalho Paletizacao',
      placeholder: 'Template do cabecalho da cobranca de paletizacao',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 6 },
      rows: 4
    },
    {
      name: 'templateItensPaletizacao',
      label: 'Itens Paletizacao',
      placeholder: 'Template repetido por NF na cobranca de paletizacao',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 6 },
      rows: 4
    }
  ],
  [
    {
      name: 'templateCabecalhoEtiquetagem',
      label: 'Cabecalho Etiquetagem',
      placeholder: 'Template do cabecalho da cobranca de etiquetagem',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 6 },
      rows: 4
    },
    {
      name: 'templateItensEtiquetagem',
      label: 'Itens Etiquetagem',
      placeholder: 'Template repetido por NF na cobranca de etiquetagem',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 6 },
      rows: 4
    }
  ],
  [
    {
      name: 'templateCabecalhoArmazenagem',
      label: 'Cabecalho Armazenagem',
      placeholder: 'Template do cabecalho da cobranca de armazenagem',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 6 },
      rows: 4
    },
    {
      name: 'templateItensArmazenagem',
      label: 'Itens Armazenagem',
      placeholder: 'Template repetido por NF na cobranca de armazenagem',
      component: 'Textarea',
      type: 'textarea',
      colProps: { md: 6 },
      rows: 4
    }
  ]
];

export const depositoClienteFormSections = () => [
  { title: 'Cliente', rows: [0] },
  { title: 'Periodo Emissao', rows: [1] },
  { title: 'Acesso Publico', rows: [2] },
  { title: 'Responsaveis', rows: [3] },
  { title: 'Observacoes Emissao', rows: [4] },
  { title: 'Templates de Cobranca', rows: [5, 6, 7] }
];

export const validateDepositoClienteForm = (values) => {
  const errors = {};

  if (!values.cnpjCliente || values.cnpjCliente.trim().length === 0) {
    errors.cnpjCliente = 'CNPJ e obrigatorio';
  }

  if (!values.diasRecorrencia && values.diasRecorrencia !== 0) {
    errors.diasRecorrencia = 'Dias de recorrencia e obrigatorio';
  }

  if (values.diaEmissaoInicial !== undefined && values.diaEmissaoInicial !== null && values.diaEmissaoInicial !== '') {
    const diaInicial = Number(values.diaEmissaoInicial);
    if (Number.isNaN(diaInicial) || diaInicial < 1 || diaInicial > 31) {
      errors.diaEmissaoInicial = 'Dia inicial deve estar entre 1 e 31';
    }
  }

  if (values.diaEmissaoFinal !== undefined && values.diaEmissaoFinal !== null && values.diaEmissaoFinal !== '') {
    const diaFinal = Number(values.diaEmissaoFinal);
    if (Number.isNaN(diaFinal) || diaFinal < 1 || diaFinal > 31) {
      errors.diaEmissaoFinal = 'Dia final deve estar entre 1 e 31';
    }
  }

  if (
    values.diaEmissaoInicial !== undefined && values.diaEmissaoInicial !== null && values.diaEmissaoInicial !== '' &&
    values.diaEmissaoFinal !== undefined && values.diaEmissaoFinal !== null && values.diaEmissaoFinal !== ''
  ) {
    const diaInicial = Number(values.diaEmissaoInicial);
    const diaFinal = Number(values.diaEmissaoFinal);
    if (!Number.isNaN(diaInicial) && !Number.isNaN(diaFinal) && diaInicial > diaFinal) {
      errors.diaEmissaoFinal = 'Dia final deve ser maior ou igual ao dia inicial';
    }
  }

  return errors;
};
